import { Routes } from '@angular/router';

import { AdminRoleGuard, authGuard } from '../auth';

export const editorialRoutes: Routes = [
  {
    path: '',
    canActivate: [authGuard, AdminRoleGuard],
    canActivateChild: [authGuard, AdminRoleGuard],
    data: { label: 'Editorial', translationKey: 'navigation.editorial', labelSource: null },
    children: [
      { path: '', redirectTo: 'insights/culture-overviews', pathMatch: 'full' },
      {
        path: 'insights/culture-overviews',
        loadComponent: () => import('./culture-overviews/culture-overviews.component').then((m) => m.CultureOverviewsComponent),
        data: { label: 'Culture overviews', translationKey: 'navigation.culture_overviews', labelSource: null },
      },
    ],
  },
];
